"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("react");
var useAppRestart_api_1 = require("./useAppRestart.api");
var isRestarting = false;
function useAppRestart() {
  var restartingRef = (0, react_1.useRef)(isRestarting);
  return (0, react_1.useCallback)(function (path) {
    if (restartingRef.current) {
      return;
    }
    restartingRef.current = isRestarting = true;
    (0, useAppRestart_api_1.restart)(path);
  }, []);
}
exports.default = useAppRestart;